import React from "react";
import { useQuery } from "react-query";
import { getExpenseAccount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetExpenseAccount = () => {
  return useQuery("GetExpenseAccount", getExpenseAccount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetExpenseAccount;
